module.exports = __webpack_public_path__ + "media/images/red_bubble-5374e217bcc306ff0dbe488b79711350.png";